import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
//
import { EN_US } from './langs/en/index.translation';

// ----------------------------------------------------------------------

const resources = {
  EN_US,
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'EN_US',
});

export default i18n;
